import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-row gap-5 align-items-center mb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "align-middle" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Email is send when")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "align-middle" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "for")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "align-middle" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "days")
], -1)
const _hoisted_6 = { class: "d-flex flex-column mb-5" }
const _hoisted_7 = { class: "d-flex flex-row justify-content-end mb-0" }
const _hoisted_8 = { class: "w-25" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-flex fs-6 fw-bold" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "SMS Body Template")
  ])
], -1)
const _hoisted_11 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_12 = { class: "d-flex justify-content-end mb-5" }
const _hoisted_13 = { class: "badge badge-lg badge-light" }
const _hoisted_14 = { class: "d-flex flex-row justify-content-between mb-10" }
const _hoisted_15 = ["data-kt-indicator"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Delete ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }),
  /*#__PURE__*/_createTextVNode(" Deleting... ")
], -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = ["data-kt-indicator"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }),
  /*#__PURE__*/_createTextVNode(" Please wait... ")
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_PlaceholderSelect = _resolveComponent("PlaceholderSelect")!
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: _ctx.formData.send_when,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.send_when) = $event)),
        placeholder: "Send When",
        size: "large",
        clearable: "",
        "default-first-option": "true"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reminderOptions, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_component_el_input_number, {
        name: "no_of_days",
        modelValue: _ctx.formData.no_of_days,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.no_of_days) = $event)),
        placeholder: "No of days",
        min: 1,
        max: 21,
        onChange: _ctx.handleNoOfDaysChange
      }, null, 8, ["modelValue", "onChange"]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_PlaceholderSelect, {
            options: _ctx.placeholderOptions,
            onChange: _ctx.handlePlaceholderSelect
          }, null, 8, ["options", "onChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Editor, {
            "output-format": "text",
            modelValue: _ctx.formData.body,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.body) = $event)),
            "api-key": _ctx.api_key,
            init: _ctx.config,
            onKeyPress: _ctx.limitInput,
            onPaste: _ctx.limitInput,
            ref: "editorInput",
            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleElementFocus('editorInput')))
          }, null, 8, ["modelValue", "api-key", "init", "onKeyPress", "onPaste"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formData.body?.length ?? 0) + "/" + _toDisplayString(_ctx.max_length), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleClickDelete && _ctx.handleClickDelete(...args))),
        class: "btn btn-new-design-secondary",
        "data-kt-indicator": _ctx.actionLoading ? 'on' : null
      }, _hoisted_18, 8, _hoisted_15),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSubmitForm && _ctx.handleSubmitForm(...args))),
        class: "btn btn-new-design-primary fw-bolder ms-4",
        "data-kt-indicator": _ctx.formSubmitted ? 'on' : null
      }, _hoisted_22, 8, _hoisted_19)
    ])
  ]))
}